module.exports = __webpack_public_path__ + "static/img/title2.616b075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/title2.png
// module id = v4pO
// module chunks = 1